module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('p', {
    staticClass: "CT-VERSO"
  }, [_vm._v("“No swimming for an hour after lunch—you’ll "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("cramp up!”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "COT"
  }, [_vm._v("Perhaps no piece of dubious parental wisdom has ever been followed so precisely as this one. Stopwatches have been employed to make sure that no toe was dipped in pool water within one hour of the last bite of deviled egg or Oreo entering a child’s mouth. Sixty minutes and one second: you’ll be fine. Fifty-nine minutes and fifty-nine seconds: certain doom!")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As early as 1961, pediatricians were doubting this old wives’ tale, but it’s hung on stubbornly. It is true that when we eat, our body diverts blood to the stomach to aid in digestion, but, as you may have noticed after every meal you ever ate in your life, that doesn’t immediately immobilize your arms and legs. Any kind of exercise after a big meal can be uncomfortable, so I wouldn’t recommend swimming the English Channel right after Thanksgiving dinner. But there’s nothing magically fatal about the combination of food and chlorinated water. If you’re swimming after lunch and start to feel a stitch, or bloated, or crampy, just hop out of the pool. Not one water death has ever been attributed to post-meal cramping, and the American Red Cross doesn’t include any food warnings in its lengthy swimming-safety guidelines. In fact, long-distance swimmers are routinely fed in the middle of long races, to make sure they stay nourished and hydrated.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The only dangerous lunch for swimmers would be a Don Draper–style one that included a martini or two. There are about 3,500 fatal drownings in the U.S. every year, and the Centers for Disease Control says that alcohol is one of the most common factors linking them, since it can throw off a swimmer’s coordination and judgment, especially in combination with sun and heat. A 1990 California study found that fully 41 percent of the state’s drowning deaths were alcohol related. So listen up, moms and dads—Popsicles by the pool: fine. Peach vodka Popsicles: maybe less so.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "18",
      "src": "images/f0007-01.jpg",
      "width": "120"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "TF"
  }, [_vm._v("FALSE.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-722da8a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 84
// module chunks = 0